/**
 * Feature hook: Channel store state + fetchChannelConfig thunk (uses channelAPI).
 */
import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../hooks";
import { fetchChannelConfig, updateChannelDescriptionThunk, fetchIsPrimaryChannel } from "../slices/channel/channelThunks";

export function useChannel() {
  const dispatch = useAppDispatch();
  const channelState = useAppSelector((state) => state.ChannelStore);
  const onChannelConfigLoad = useCallback(
    (teamsContext) => dispatch(fetchChannelConfig(teamsContext)),
    [dispatch]
  );
  const onUpdateChannelDescription = useCallback(
    (teamsContext, description) => dispatch(updateChannelDescriptionThunk({ teamsContext, description })),
    [dispatch]
  );
  const onCheckIsPrimaryChannel = useCallback(
    (teamsContext) => dispatch(fetchIsPrimaryChannel(teamsContext)),
    [dispatch]
  );

  return {
    ...channelState,
    onChannelConfigLoad,
    onUpdateChannelDescription,
    onCheckIsPrimaryChannel,
  };
}
